import { getFeedGraph } from 'views/planning-prognosis/api/get-total-feed';
import { FeedGraph } from '../../../types/feed-graph.type';

//POST
// /ewosapi/v1/planandprognosis/${globalCompanyId}graph/sites/totalfeed
// get feed for a single site belonging to one company. wrapper using total feed endpoint as they are identical. this takes a single globalSiteId as a parameter
export const getSiteFeed = async (globalCompanyId: string, globalSiteId: string, periodType: number = 1): Promise<FeedGraph> => {
  return getFeedGraph(globalCompanyId, { sites: [globalSiteId] }, periodType);
};
